module.exports = __webpack_public_path__ + "static/media/hand.0f356d30.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Landing/hand.png
// module id = 269
// module chunks = 0